import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PaginationInstance} from 'ngx-pagination';

@Component({
    selector: 'app-m-pagination-control',
    templateUrl: './m-pagination-control.component.html',
    styleUrls: ['./m-pagination-control.component.scss'],
    preserveWhitespaces: true
})
export class MPaginationControlComponent implements OnInit, OnDestroy {

    @Input() rowsPerPage = 20;
    @Input() config: PaginationInstance;
    @Input() name = '';
    @Output() pageChange = new EventEmitter();

    public rowsPerPageOptions: Array<any>;

    constructor() {
    }

    ngOnInit() {
        this.rowsPerPageOptions = [
            {label: '10', value: '10'},
            {label: '20', value: '20'},
            {label: '50', value: '50'}
        ];
    }

    ngOnDestroy() {
        this.pageChange.unsubscribe();
    }

    onPage(event) {
        this.rowsPerPage = event.rows;
        this.emitValues();
    }

    onRowsPerPageChange(value) {
        this.rowsPerPage = value;
        this.config.itemsPerPage = value;
        this.config.currentPage = 1;
        this.emitValues();
    }

    onRefresh() {
        this.emitValues();
    }

    private emitValues() {
        this.pageChange.emit({rowsPerPage: this.config.itemsPerPage, page: this.config.currentPage - 1});
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/components/pagination-control/m-pagination-control.component.ts